class OrderBySearchStates {
    static DISTANCE_CLOSEST = Symbol("DISTANCE_CLOSEST");
    static PRICE_HIGH_TO_LOW = Symbol("PRICE_HIGH_TO_LOW");
    static PRICE_LOW_TO_HIGH = Symbol("PRICE_LOW_TO_HIGH");
}

export default OrderBySearchStates;
